import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material';
import TagManager, { TagManagerArgs } from 'react-gtm-module';
import { ApolloProvider } from '@apollo/client';
import apolloClient from '@/config/apolloClient';

import { useCustomTheme } from './theme/materialTheme';
import ScrollRestorationProvider from './context/ScrollRestorationProvider';
import FlyersProvider from './context/FlyersProvider';
import AuthenticationProvider from './context/AuthenticationProvider';
import { NavigationProvider } from './context/NavigationContext';
import App from './App';
import config from '@/config/config';
import UserPreferencesProvider from './context/UserPreferencesProvider';
import { ViewModeProvider } from './context/ViewModeContext';

const tagManagerArgs: TagManagerArgs = {
  gtmId: config.REACT_APP_GTM_TAG || '',
};

TagManager.initialize(tagManagerArgs);

const AppContainer: React.FC = () => {
  const theme = useCustomTheme();
  return (
    <ThemeProvider theme={theme}>
      <ApolloProvider client={apolloClient}>
        <CssBaseline />
        <BrowserRouter>
          <ScrollRestorationProvider>
            <ViewModeProvider>
              <FlyersProvider>
                <UserPreferencesProvider>
                  <AuthenticationProvider>
                    <NavigationProvider>
                      <App />
                    </NavigationProvider>
                  </AuthenticationProvider>
                </UserPreferencesProvider>
              </FlyersProvider>
            </ViewModeProvider>
          </ScrollRestorationProvider>
        </BrowserRouter>
      </ApolloProvider>
    </ThemeProvider>
  );
};

export default AppContainer;
